import { TRACKERS } from "@/constants/Trackers";
import { ExternalCareTeam } from "@/features/Patient/MedicalRecords/ExternalCareTeam/ExternalCareTeam";
import { trackEvent } from "@/lib/tracking";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/patient/$patientId/external-care-team")({
  component: RouteComponent,
  onEnter: async () => {
    trackEvent(TRACKERS.NAVIGATE_TO_EXTERNAL_CARE_TEAM);
  },
});

function RouteComponent() {
  return <ExternalCareTeam />;
}
